module.exports = __webpack_public_path__ + "img/rates.9a39f81c.svg";